var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMaleGrooming = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Beard-Style-Shaving-Machine--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Beard Style Shaving Machine Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 15.75h3s0.5 0 0.5 0.5v2s0 0.5 -0.5 0.5h-3s-0.5 0 -0.5 -0.5v-2s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0a1 1 0 0 0 -1 1v2a0.5 0.5 0 0 1 -1 0V1a1 1 0 0 0 -2 0v2a0.5 0.5 0 0 1 -1 0V1a1 1 0 0 0 -2 0v2a0.5 0.5 0 0 1 -1 0V1a1 1 0 0 0 -2 0v2a0.5 0.5 0 0 1 -1 0V1a1 1 0 0 0 -2 0v3a1 1 0 0 0 0.6 0.89 0.49 0.49 0 0 1 0.27 0.31l0.43 1.27a1.48 1.48 0 0 0 1.42 1h8.56a1.48 1.48 0 0 0 1.42 -1l0.43 -1.27a0.49 0.49 0 0 1 0.27 -0.31A1 1 0 0 0 19 4V1a1 1 0 0 0 -1 -1Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88 8.68a0.53 0.53 0 0 0 -0.39 -0.18h-9a0.53 0.53 0 0 0 -0.39 0.18 3.74 3.74 0 0 0 -0.87 2.4v7.16a5.75 5.75 0 0 0 11.5 0v-7.15a3.74 3.74 0 0 0 -0.87 -2.4ZM15 20.3a0.52 0.52 0 0 1 -0.11 0.32 3.72 3.72 0 0 1 -5.78 0A0.52 0.52 0 0 1 9 20.3v-5.8a3 3 0 0 1 6 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMaleGrooming);
export default ForwardRef;